import { render, staticRenderFns } from "./DialogCreateFolder.vue?vue&type=template&id=493908da"
import script from "./DialogCreateFolder.vue?vue&type=script&lang=js"
export * from "./DialogCreateFolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports